import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy, isPlatform } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import * as Sentry from '@sentry/angular';
import { Router } from '@angular/router';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ShoppingService } from './services/shared/shopping.service';
import { CashbackService } from './services/cashback/cashback.service';
import { AirportListService } from './services/airport/airport-list.service';
import { EventService } from './services/events/event.service';
import { HelperService } from './services/helper/helper.service';
import { AnalyticsService } from './services/analytics/analytics.service';
import { SlugifyPipe } from './pipes/slugify.pipe';
import { RequestInterceptor } from './services/requestinterceptor';
import { UISharedModule } from './modules/shared/ui-shared.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { PushNotificationService } from './services/push-notification/push-notification.service';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { AngularFireModule } from '@angular/fire/compat';
import { HapticServiceService } from './services/hardware-service/haptic-service/haptic-service.service';
import { CalendarEventsService } from './services/calendar-events/calendar-events.service';
import { BarcodeScannerService } from './services/hardware-service/barcode-scanner/barcode-scanner.service';
import { DatePipe } from '@angular/common';
import { Calendar } from '@awesome-cordova-plugins/calendar/ngx';
import { AppUpdateService } from './services/app-update/app-update.service';
import { GlobalErrorHandler } from './services/global-error-handler';

export const languageLoader = (http: HttpClient) =>
  new TranslateHttpLoader(http, 'assets/i18n/', '.json');
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot({
      rippleEffect: !isPlatform('ios'),
      mode: 'md',
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: languageLoader,
        deps: [HttpClient],
      },
    }),
    AppRoutingModule,
    HttpClientModule,
    UISharedModule,
    ServiceWorkerModule.register('combined-sw.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireMessagingModule,
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    Calendar,
    ShoppingService,
    CashbackService,
    AirportListService,
    EventService,
    HelperService,
    AnalyticsService,
    SlugifyPipe,
    PushNotificationService,
    HapticServiceService,
    BarcodeScannerService,
    DatePipe,
    CalendarEventsService,
    AppUpdateService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
